import React, { useState } from 'react';
import { Check, Copy, Instagram, Mail } from 'lucide-react';
import { Layout } from '../components/layout/Layout';

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText('info@lumenverde.hu');
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Layout>
      <div className="section-padding">
        <div className="container-zinga">
          <div className="max-w-4xl">
            <h1 className="font-display text-3xl md:text-5xl font-bold mb-4">Kapcsolat</h1>
            <p className="max-w-2xl text-foreground/75 leading-relaxed mb-8">
              Ha kérdésed van a termékekről, rendelésről vagy együttműködésről, írj nekünk
              bizalommal. Rövid időn belül válaszolunk.
            </p>
          </div>

          <div className="relative max-w-3xl overflow-hidden rounded-[2rem] border border-[#0F3D2C] bg-background p-3 md:p-4 shadow-[0_16px_40px_rgba(15,61,44,0.08)]">
            <div className="relative grid gap-3 sm:grid-cols-2">
              <a
                href="mailto:info@lumenverde.hu"
                className="group block w-full"
              >
                <div className="rounded-[1.5rem] border border-[#0F3D2C]/15 bg-background p-4 transition-colors group-hover:border-[#0F3D2C]/25">
                  <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-[#0F3D2C]/10 text-[#0F3D2C]">
                    <Mail className="h-4 w-4" />
                  </div>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#0F3D2C]/70">E-mail</p>
                  <div className="mt-2 inline-flex items-center gap-2 rounded-xl bg-[#0F3D2C] px-3 py-2">
                    <p className="text-lg font-semibold text-[#F6D797]">info@lumenverde.hu</p>
                    <button
                      type="button"
                      onClick={handleCopyEmail}
                      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#F6D797]/20 bg-[#F6D797]/10 text-[#F6D797] transition-colors hover:bg-[#F6D797]/20"
                      aria-label="E-mail cím másolása"
                      title={copied ? 'Kimásolva' : 'Másolás'}
                    >
                      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                    </button>
                  </div>
                  <p className="mt-2 text-sm text-[#0F3D2C]/75">Írj nekünk bármilyen kérdéssel.</p>
                </div>
              </a>

              <a
                href="https://www.instagram.com/lumen.verde/"
                target="_blank"
                rel="noopener noreferrer"
                className="group block w-full"
              >
                <div className="rounded-[1.5rem] border border-[#0F3D2C]/15 bg-background p-4 transition-colors group-hover:border-[#0F3D2C]/25">
                  <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-[#0F3D2C]/10 text-[#0F3D2C]">
                    <Instagram className="h-4 w-4" />
                  </div>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#0F3D2C]/70">Instagram</p>
                  <div className="mt-2 inline-flex items-center gap-2 rounded-xl bg-[#0F3D2C] px-3 py-2">
                    <p className="text-lg font-semibold text-[#F6D797]">lumen.verde</p>
                  </div>
                  <p className="mt-2 text-sm text-[#0F3D2C]/75">Kövess minket a friss hírekért és újdonságokért.</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
